import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SelectPlan from "./SelectPlan";
import CustomizePlan from "./CustomizePlan";
import PaymentSuccessful from "./PaymentSuccessful";
import DialogWrapper from "./DialogWrapper";
import { setCurrentPricingDialog } from "../../../store/actions/account";
import {
  Switch,
  Route,
  useHistory,
  Redirect,
  useRouteMatch
} from "react-router-dom";
import BillingInfo from "./BillingInfoForm";
import CancelSubscription from "./CancelSubscription";
import { currencies } from "../../data/constants";

function PlansDialog({
  open,
  drawerExpanded,
  setCurrentPricingDialog,
  vehiclesCount,
  setActiveModal = () => {},
  setPricingOpen = () => {},
  userData
}) {
  const plan =
    (userData.organisationSite &&
      userData.organisationSite.organisation.plan) ||
    {};

  const [chosenPlan, setChosenPlan] = useState(null);
  let [currency, setCurrency] = useState({ symbol: "$", string: "USD" });

  const history = useHistory();
  const locationState = useRef();

  const match = useRouteMatch("/payment/edit-payment-method");

  useEffect(() => {
    locationState.current = history.location.state;
    setPricingOpen(true);
    return () => {
      if (!open) {
        setCurrentPricingDialog("selectPlan");
        setPricingOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleClose = () => {
    if (locationState.current && locationState.current.from === "billing") {
      history.replace("/billing");
    } else {
      if (sessionStorage.currentProject) {
        history.replace(`/${sessionStorage.currentProject}`, {
          action: "closeDrawer"
        });
      } else {
        history.replace("");
      }
    }
  };

  const organisation =
    userData.organisationSite && userData.organisationSite.organisation;

  const incompleteAccount =
    organisation &&
    organisation.subscription_last_payment_status ===
      "requires_payment_method" &&
    organisation.subscription_status === "incomplete";

  const incompletePayment =
    organisation &&
    organisation.subscription_last_payment_status === "requires_action" &&
    organisation.subscription_status === "incomplete";

  useEffect(() => {
    // set initially selected currency
    if (plan && plan.currency) {
      setCurrency({ ...currencies[plan.currency.toUpperCase()], loaded: true });
    }
  }, [plan]);

  const [loading, setLoading] = useState(false);

  return (incompleteAccount || incompletePayment) && !match?.isExact ? (
    <Redirect to="/" />
  ) : (
    <DialogWrapper
      open={open}
      handleClose={handleClose}
      drawerExpanded={drawerExpanded}
      loading={loading}
    >
      <Switch>
        {/* Cancel subsription / deactivate account */}
        <Route path="/payment/cancel-subscription" exact>
          <CancelSubscription
            handleClose={handleClose}
            drawerExpanded={drawerExpanded}
            open={open}
            setLoading={setLoading}
          />
        </Route>

        {/* Main route, plans info */}
        <Route path={"/payment/select-plan"}>
          <SelectPlan
            handleClose={handleClose}
            drawerExpanded={drawerExpanded}
            setChosenPlan={setChosenPlan}
            open={true}
            currency={currency}
            setCurrentDialog={setCurrentPricingDialog}
            setActiveModal={setActiveModal}
            plan={plan}
          />
        </Route>

        {/* Success after submitting payment info */}
        <Route path="/payment/success">
          <PaymentSuccessful
            handleClose={handleClose}
            drawerExpanded={drawerExpanded}
            open={open}
            currency={currency}
            plan={plan}
            setCurrentDialog={setCurrentPricingDialog}
            chosenPlan={chosenPlan}
            vehiclesCount={vehiclesCount}
          />
        </Route>

        {/* Payment info form */}
        <Route
          path={["/payment/:planId/billing", "/payment/edit-payment-method"]}
        >
          <BillingInfo
            drawerExpanded={drawerExpanded}
            open={open}
            currency={currency}
            setCurrentDialog={setCurrentPricingDialog}
            chosenPlan={chosenPlan}
            vehiclesCount={vehiclesCount}
            setLoading={setLoading}
            handleClose={handleClose}
          />
        </Route>

        {/* Switch/select plan */}
        <Route path="/payment/:planId" exact>
          <CustomizePlan
            handleClose={handleClose}
            drawerExpanded={drawerExpanded}
            open={open}
            currency={currency}
            setCurrentDialog={setCurrentPricingDialog}
            chosenPlan={chosenPlan}
            setActiveModal={setActiveModal}
            vehiclesCount={vehiclesCount}
            setLoading={setLoading}
            plan={plan}
          />
        </Route>
      </Switch>
    </DialogWrapper>
  );
}

const mapStateToProps = state => ({
  userData: state.auth.userData,

  vehiclesCount: state.project.vehicleTypes.length,
  currentDialog: state.account.currentPricingDialog
});

export default connect(mapStateToProps, { setCurrentPricingDialog })(
  PlansDialog
);
